export default {
  pages: {
    key: 'title',
    data: [
      {
        title: 'Error 404', url: '/no-existo', icon: 'FileIcon', is_bookmarked: false,
      },
    ],
  },
};
